<template>
  <div class="social">
    <div class="wrap">
      <div class="page-container">
        <div class="flex-col-vertical-center content">
          <div class="title">
            <h2>{{ $t('home.social.title') }}</h2>
          </div>
          <div class="icons">
            <a
              v-for="(link, index) in links"
              :key="link.name + index"
              :href="link.to"
              :aria-label="link.name"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div :class="link.name">
                <img :src="link.img" alt />
                <p>{{ link.name | capitalize }}</p>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import discord from '@/assets/images/icons/discord.png';
import reddit from '@/assets/images/icons/reddit.svg';
import telegram from '@/assets/images/icons/telegram.png';
import twitter from '@/assets/images/icons/twitter.jpg';
import facebook from '@/assets/images/icons/facebook.png';

export default {
  data() {
    return {
      links: [
        {
          img: facebook,
          to: 'https://www.facebook.com/mintmeproject',
          name: 'Facebook'
        },
        {
          img: twitter,
          to: 'https://twitter.com/mintmeproject',
          name: 'Twitter'
        },
        {
          img: telegram,
          to: 'https://t.me/webchainnetwork',
          name: 'Telegram'
        },
        {
          img: reddit,
          to: 'https://www.reddit.com/r/MintMeCom',
          name: 'reddit'
        },
        {
          img: discord,
          to: 'https://discord.com/invite/uuZXhCn',
          name: 'discord'
        }
      ]
    };
  }
};
</script>

<style lang="scss" scoped>
@import 'Social.scss';
</style>
